export const ABHA_WIDGET = 'AbhaWidget'
export const ABHA_SEO_WIDGET = 'abha-seo-widget'
export const CHALLAN_WIDGET_LANDING = 'challan-widget-landing-page'
export const FASTAG_WIDGET_LANDING = 'fastag-widget-landing-page'
export const HSRP_WIDGET_LANDING = 'hsrp-widget-landing-page'
export const RTO_WIDGET = 'RTOWidget'
export const VAS_LANDING_PAGE_WIDGETS: string[] = [
  CHALLAN_WIDGET_LANDING,
  FASTAG_WIDGET_LANDING,
  HSRP_WIDGET_LANDING,
  RTO_WIDGET,
]
export const TAP_BTN_EVENT = 'tap_btn_CTA_widget'
export const FIND_THE_RIGHT_PLAN = 'Find the Right Plan'
export const CTA_DEFAULT_ENDPOINT = 'https://www.acko.com/p/health/as/inputDetails'
export const WHATSAPP_FLOW = 'ldnt'
export const VARIANT_ID = 'variant_id'
export const FUNNEL_TYPE = {
  ENGAGE: 'engage',
  ENTRY: 'entry',
}
